"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GameVars_1 = require("./GameVars");
var AudioManager = /** @class */ (function () {
    function AudioManager() {
        if (AudioManager._instance) {
            throw new Error("Error: Instantiation failed: Use GameVars.getInstance() instead of new");
        }
        else {
            AudioManager._instance = this;
        }
    }
    AudioManager.getInstance = function () {
        if (AudioManager._instance === null) {
            AudioManager._instance = new AudioManager();
        }
        return AudioManager._instance;
    };
    AudioManager.prototype.init = function (game) {
        this.game = game;
        this.loopPlayingKey = null;
        this.audioSprite = this.game.add.audioSprite("audio-sprite");
        if (!GameVars_1.GameVars.sound) {
            AudioManager.getInstance().mute();
        }
    };
    Object.defineProperty(AudioManager.prototype, "isSoundMuted", {
        get: function () {
            return this._isSoundMuted;
        },
        set: function (value) {
            this._isSoundMuted = value;
        },
        enumerable: true,
        configurable: true
    });
    AudioManager.prototype.playSound = function (key, volume, loop) {
        if (this._isSoundMuted) {
            return;
        }
        loop = loop || false;
        if (key !== this.loopPlayingKey) {
            this.audioSprite.play(key, volume);
        }
        if (loop) {
            if (this.loopPlayingKey && (this.loopPlayingKey !== key)) {
                this.stopSound(this.loopPlayingKey, false, true);
            }
            this.loopPlayingKey = key;
        }
    };
    AudioManager.prototype.stopSound = function (key, fade, loop) {
        if (key === null || typeof key === "undefined") {
            return;
        }
        if (fade) {
            var sound = this.audioSprite.get(key);
            sound.fadeOut(850);
        }
        else {
            this.audioSprite.stop(key);
        }
        if (loop) {
            this.loopPlayingKey = null;
        }
    };
    AudioManager.prototype.mute = function () {
        this.game.sound.mute = true;
    };
    AudioManager.prototype.unmute = function () {
        this.game.sound.mute = false;
    };
    AudioManager._instance = null;
    return AudioManager;
}());
exports.AudioManager = AudioManager;
